import { OVERFLOW_SIDE } from './constants';
import { OverflowSide } from './types';

type OverflowSides = OverflowSide[];

const getOverflowSides = (
  contentWidth: number,
  pagePadding: number,
  placementStyles: {
    top: number;
    left: number;
  }
): OverflowSides | null => {
  const overflowSides: OverflowSides = [];

  if (placementStyles.top < window.scrollY + pagePadding) {
    overflowSides.push(OVERFLOW_SIDE.TOP);
  }

  if (placementStyles.left < pagePadding) {
    overflowSides.push(OVERFLOW_SIDE.LEFT);
  }

  if (placementStyles.left + contentWidth > window.innerWidth - pagePadding) {
    overflowSides.push(OVERFLOW_SIDE.RIGHT);
  }

  if (overflowSides.length) {
    return overflowSides;
  }

  return null;
};

export default getOverflowSides;
